import { createSelector } from '@ngrx/store';
import {
  WelcomePackStatusStepHttpModel,
  WelcomePackStepEnum,
} from '../../http/welcome-pack/welcome-pack-http.models';
import { selectFeatureStore } from './generic.selectors';

export const selectWelcomePackStatus = createSelector(
  selectFeatureStore,
  ({ welcomePackStatus }) => welcomePackStatus,
);

export const selectWelcomePackNextStep = createSelector(
  selectWelcomePackStatus,
  (welcomePackStatus) => {
    const currentStep =
      getStepByName(welcomePackStatus.steps, welcomePackStatus.currentStep) ??
      getStepByNumber(welcomePackStatus.steps, 0);
    if (!currentStep) {
      return WelcomePackStepEnum.error;
    }

    const nextStep = getStepByNumber(
      welcomePackStatus.steps,
      currentStep.number + 1,
    );
    if (!nextStep) {
      return WelcomePackStepEnum.error;
    }

    return nextStep.name;
  },
);

export const selectWelcomePackPreviousStep = createSelector(
  selectWelcomePackStatus,
  (welcomePackStatus) => {
    const currentStep = getStepByName(
      welcomePackStatus.steps,
      welcomePackStatus.currentStep,
    );
    if (!currentStep) {
      return WelcomePackStepEnum.error;
    }

    const nextStep = getStepByNumber(
      welcomePackStatus.steps,
      currentStep.number - 1,
    );
    if (!nextStep) {
      return WelcomePackStepEnum.error;
    }

    return nextStep.name;
  },
);

const getStepByName = (
  steps: Array<WelcomePackStatusStepHttpModel>,
  step: WelcomePackStepEnum | null,
): WelcomePackStatusStepHttpModel | undefined =>
  steps.find((s) => s.name === step);

const getStepByNumber = (
  steps: Array<WelcomePackStatusStepHttpModel>,
  step: number | null,
): WelcomePackStatusStepHttpModel | undefined =>
  steps.find((s) => s.number === step);
